import React from 'react';
import { usePWAInstall } from '../hooks/usePWAInstall';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const PWABanner: React.FC = () => {
    const { t } = useTranslation();
    const { isInstallable, isIOS, isStandalone, promptInstall } = usePWAInstall();
    const location = useLocation();

    // Hide in demo/screenshot mode
    if (localStorage.getItem('aura_demo_mode') === 'true') return null;

    // Hide on login, register, landing, and onboarding to keep them clean
    const hidePaths = ['/', '/login', '/register', '/questionnaire', '/basic-welcome', '/premium-welcome'];
    if (hidePaths.includes(location.pathname)) return null;

    if (isStandalone) return null;

    return (
        <div className="bg-gradient-to-r from-[#D4AF37] to-[#AA8A2E] text-black px-4 py-2 flex items-center justify-between shadow-md relative z-[60]">
            <div className="flex flex-col">
                <span className="text-[10px] font-black uppercase tracking-widest leading-tight">Aura Method</span>
                <span className="text-[9px] font-bold opacity-80">{t('pwa.install_banner_subtitle', 'Mejor rendimiento. Cero distracciones.')}</span>
            </div>
            
            <button 
                onClick={() => {
                    if (isInstallable) {
                        promptInstall(); // Instalación directa de 1 clic en Chrome/Android
                    } else {
                        // Abrir el modal visual de instrucciones en iOS / otros
                        const event = new Event('aura-show-pwa-prompt');
                        window.dispatchEvent(event);
                    }
                }}
                className="bg-black text-[#D4AF37] text-[10px] font-black uppercase tracking-wider px-3 py-1.5 rounded-lg shadow-sm hover:scale-105 active:scale-95 transition-transform flex items-center gap-1"
            >
                <span className="material-symbols-outlined text-[14px]">download</span>
                {t('pwa.install_banner', 'Instalar App')}
            </button>
        </div>
    );
};
